import type { EventCompletionStatusType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import { lazyLogFloodgateActivity, SurveyActivityType } from 'owa-floodgate-feedback-view';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

export default async function (
    completionStatus: EventCompletionStatusType,
    isNewEvent: boolean,
    isMeeting: boolean
): Promise<void> {
    if (completionStatus == 'Saved') {
        let activityType: SurveyActivityType;
        if (isNewEvent) {
            activityType = isMeeting ? 'MeetingCreated' : 'AppointmentCreated';
        } else {
            activityType = isMeeting ? 'MeetingUpdated' : 'AppointmentUpdated';
        }

        // Log floodgate activity for the corresponding activity type. If the user doesn't belong to this group, triggering will be a no-op.
        if (isHostAppFeatureEnabled('floodgate')) {
            const logFloodgateActivity = await lazyLogFloodgateActivity.import();
            logFloodgateActivity(activityType);
        }
    }
}
